<template>
  <div
    class="progress-line prgsline"
    :style="`--anim-duration:${seconds}s`"
  ></div>
</template>

<script>
export default {
  name: 'ProgressLine',
  props: {
    seconds: { default: () => 2 },
  },
}
</script>
<style lang="scss" scoped>
.prgsline {
  width: 100%;
  position: relative;
  // border-radius: 4px;
  overflow: hidden;
  --anim-duration: 2s;
  --clr-line: var(--clr-primary);
  --clr-back: var(--clr-black-2);
  --start: 0%;
  --end: 100%;
  --height: 4px;
  --radius: 0px;
  --radius-progress: 4px;
  border-radius: var(--radius);
  background: var(--clr-back);
  height: var(--height);
  &_reverse {
    --end: 0%;
    --start: 100%;
  }
  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    border-radius: var(--radius-progress);
    // border-top-right-radius: 4px;
    // border-bottom-right-radius: 4px;
    height: 100%;
    width: var(--end);
    transition: 0.44s;
    background: var(--clr-line);
  }
  &:not(.prgsline_no-animate) {
    &::before {
      animation: FillMe var(--anim-duration) infinite;
    }
  }
}
@keyframes FillMe {
  0% {
    width: var(--start);
  }
  100% {
    width: var(--end);
  }
}
</style>
